import type { BenchmarkingEntityType } from 'src/components/agent-forms/BenchmarkingAgentConfigForm'

/** The Focus card only ever holds one entity kind at a time, so its copy
 * names that kind directly instead of a generic label. Keyed by
 * BenchmarkingEntityType so the section/add-label/hint set stays together as
 * the toggle changes. Shared by BenchmarkUniversePanel's sub-components and
 * the entity-switch confirmation modal in BenchmarkingAgentConfigForm. */
export const ENTITY_LABELS: Record<
  BenchmarkingEntityType,
  {
    section: string
    singular: string
    addLabel: string
    emptyHint: string
  }
> = {
  brand: {
    section: 'Brands',
    singular: 'Brand',
    addLabel: '+ Add brand',
    emptyHint: 'Pick a brand to see how it compares.',
  },
  product_hierarchy: {
    section: 'Products',
    singular: 'Product',
    addLabel: '+ Add product',
    emptyHint: 'Pick a product to see how it compares.',
  },
}
